import dynamic from 'next/dynamic';

const InputFieldWithLabel = dynamic(() =>
  import('./InputFieldWithLabel/InputFieldWithLabel')
);
const FieldV2 = dynamic(() => import('./FieldV2/FieldV2'));
const InputField = dynamic(() => import('./InputField/InputField'));
const Label = dynamic(() => import('./Label/Label'));
const InputFieldV2 = dynamic(() => import('./InputFieldV2/InputFieldV2'));

export { InputFieldWithLabel, FieldV2, InputField, Label, InputFieldV2 };
